import KuanshiIcon from '../../../../static/img/kuanshi.png'
import SucaiIcon from '../../../../static/img/sucai.png'
import TuyaIcon from '../../../../static/img/tuya.png'
import WenziIcon from '../../../../static/img/wenzi.png'
import TContext from '../../context'
import { useContext, LegacyRef, useRef, useImperativeHandle, useEffect, useState } from 'react'
import { Toast } from '@nutui/nutui-react';


export const foot: React.CSSProperties = {
    width: '90px',
    height: "100%",
    position: "relative",
    left: 0,
    top: 0,
    display: "flex",
    background: '#ffffff',
    boxShadow: '0px -1px 5px 0px rgba(0,0,0,0.10)',
    zIndex: 20,
    alignItems: 'center',
    flexDirection: 'column',
    //paddingBottom: 'constant(safe-area-inset-bottom)',//兼容 IOS<11.2
    paddingBottom: 'env(safe-area-inset-bottom)',//兼容 IOS>11.2
}

export const foot_item = {
    width: '90%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    paddingTop: 10,
    paddingBottom: 10,
    marginTop: 36

}

export const foot_txt: React.CSSProperties = {
    fontSize: 16,
    fontWeight: 400,
    color: 'rgba(51, 51, 51, 1)',
    textAlign: "center",
    marginTop: 4

}

export const iconStyle = {
    width: 50,
    height: 50
}

interface option {
    icon: string
    text: string
    key: MenuType
    hidden: boolean,
    iconClass: string
}

export interface Props {
    onClick?: any
    cutpartList?: cutpartListItem[]
    swiperClient?: any
    editText?: boolean
    action?: any,
    activeMenu?: MenuType | null
    onClickMenu?: (key: MenuType) => void
}

interface cutpartListItem {
    code: string
    img: string
    show?: boolean
    camera?: any
}

export enum MenuType {
    KUANSHI = 1,
    SUCAI = 2,
    TUYA = 3,
    WENZI = 4,
    SHANGWU = 5,
    YANSHE = 6,
    LIEBIAO = 7,
}

export const options: option[] = [
    {
        icon: KuanshiIcon,
        text: "Colors",
        key: MenuType.YANSHE,
        hidden: false,
        iconClass: 'fpd-icon-layers'
    },
    {
        icon: SucaiIcon,
        text: "Images",
        key: MenuType.SUCAI,
        hidden: false,
        iconClass: 'fpd-icon-images'
    },
    {
        icon: WenziIcon,
        text: "Add Text",
        key: MenuType.WENZI,
        hidden: false,
        iconClass: 'fpd-icon-text-secondary'
    },
    //  {
    //     icon: WenziIcon,
    //     text: "列表",
    //     key: MenuType.LIEBIAO,
    //     hidden: false
    // }
]

export interface Action {
    getHeight?: () => number;
}


const Index = (props: Props) => {
    const { action, activeMenu, onClickMenu } = props
    const tc = useContext(TContext)
    const contentRef: LegacyRef<HTMLDivElement> = useRef(null)
    const [filteredCutparts, setFilteredCutparts] = useState<any>(null);
    const getHeight = () => {
        return contentRef.current?.offsetHeight as number
    }

    useImperativeHandle(props.action, (): Action => ({
        getHeight
    }));
    useEffect(() => {
        // 初始化默认选中素材菜单
        if (!props.activeMenu) {
            const defaultMenu = MenuType.YANSHE
            onClickMenu?.(defaultMenu)
            // tc?.showPlugin?.(defaultMenu)
            props.onClick?.(defaultMenu)
        }
    }, [])
    useEffect(() => {
        const cutpart = tc?.detailData?.model_materials?.cutparts?.find((item: any) => {
            return item.code === tc?.curCutpartCode;
        });
        setFilteredCutparts(cutpart);

    }, [tc?.curCutpartCode, tc?.detailData?.model_materials?.cutparts]);


    return (
        <>
            <div ref={contentRef} style={{ display: 'flex', ...foot }}>
                {
                    options?.map((v, index) => (
                        !v.hidden && <div style={{
                            ...foot_item,
                            backgroundColor: activeMenu === v.key ? '#CCCCCC' : '#ffffff',
                            // cursor: index == 0 ? 'pointer' : (filteredCutparts?.is_diy == 0 ? 'not-allowed' : 'pointer'),
                            opacity: index == 0 ? 1 : (filteredCutparts?.is_diy == 0 ? 0.5 : 1),
                            filter: index == 0 ? 'none' : (filteredCutparts?.is_diy == 0 ? 'grayscale(50%)' : 'none'),
                        } as React.CSSProperties} key={v.key} onClick={(e) => {
                            if (index !== 0 && filteredCutparts?.is_diy == 0) {
                                // 正常提示
                                Toast.text(t('This customization is not supported by the current module ！'))
                                e.stopPropagation();
                                return;
                            }
                            if (activeMenu === v.key) {
                                return;
                            }

                            e.preventDefault()
                            onClickMenu?.(v.key)
                            tc?.showPlugin!(v.key as MenuType)
                            //点击菜单按钮失去焦点
                            tc.curCanvasClient?.discardActiveObject()
                            props.onClick?.(v.key)
                        }}>
                            {/* <img style={iconStyle} src={v.icon} alt="" /> */}
                            <i className={`${(v as any).iconClass}`} style={{ width: '30px', height: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}></i>
                            <div style={foot_txt}>{t(v.text)}</div>
                        </div>
                    ))
                }
            </div>
        </>
    )
}

export default Index
